import { createAxiosInstance } from "@/services/util";
import { Floor } from "@/swagger/models";
import { defineStore } from "pinia";

const axios = createAxiosInstance();

export const useFloorStore = defineStore({
    id: "floor",
    state: () => ({}),
    actions: {
        async patch(id: number, data: Partial<Floor>): Promise<Floor> {
            const res = await axios.put<Floor>(`/floors/${id}`, data);
            console.log(res.data);
            return res.data;
        },
    },
});
